import Vue from 'vue'
import Router from 'vue-router'
// components .vue
import Intro from '../components/Page_Intro'
import About from '../components/Page_About'
import Services from '../components/Page_Services'
import Works from '../components/Page_Works'
import Project from '../components/Page_Works_Project'
import Contact from '../components/Page_Contact'

Vue.use(Router)

export default new Router({

  mode: 'history',
  base: __dirname,
  routes: [
    {
      name: 'intro',
      path: '/',
      component: Intro
    },
    {
      name: 'about',
      path: '/about',
      component: About
    },
    {
      name: 'services',
      path: '/services',
      component: Services
    },
    {
      name: 'works',
      path: '/works',
      component: Works,
      children: [
        {
          name: 'project',
          path: '/works/project/:id/:title',
          component: Project
        }
      ]
    },
    {
      name: 'contact',
      path: '/contact',
      component: Contact
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js